import * as React from 'react';

import { Row as AntdRow, Col, Divider } from 'antd';
import { Row, Text, Space } from 'farmhub-ui-core';

import { useAppSelector } from 'app';
import { CategorySelected, CheckFilterItemSkeleton, Empty } from 'components';
import { selectCategory } from 'slice';
import { getDummyArray } from 'utils';

import { DeleteText, SectionData } from './styles';

interface SelectCategoriesStepProps {
  data: any;
  isLoadingCategory: boolean;
  handleClickCategories: (e: string) => void;
  handleSelectAllOrDeleteCategories: () => void;
}

const SelectCategoriesStepDesktop = ({
  data,
  isLoadingCategory,
  handleClickCategories,
  handleSelectAllOrDeleteCategories,
}: SelectCategoriesStepProps): JSX.Element => {
  const categoryList = useAppSelector(selectCategory);

  return (
    <>
      <Row justifyContent="space-between">
        <Text color="dark" weight="bold">
          Danh sách ({categoryList.list.length}):
        </Text>
        <Row width="fit-content">
          <Text>Bạn đã chọn {data.categoryIDs.length}</Text>
          <Divider type="vertical" />
          <DeleteText onClick={handleSelectAllOrDeleteCategories}>
            {data.categoryIDs.length > 0 ? 'Xóa tất cả' : 'Chọn tất cả'}
          </DeleteText>
        </Row>
      </Row>
      <Space height={12} />
      {!isLoadingCategory && categoryList.list.length === 0 && (
        <Empty description="Không tìm thấy danh mục" minHeight={120} />
      )}
      <SectionData>
        <AntdRow gutter={[12, 12]}>
          {isLoadingCategory
            ? getDummyArray(12).map(item => (
                <Col span={8}>
                  <CheckFilterItemSkeleton key={item.key} />
                </Col>
              ))
            : categoryList.list
                .filter(item => !item.isDefault)
                .map((item: any, index: number) => (
                  <Col span={8} onClick={() => handleClickCategories(item.id)}>
                    <CategorySelected
                      key={item.id}
                      image={item.avatar}
                      selected={data.categoryIDs.includes(item.id)}
                      title={item.name}
                    />
                  </Col>
                ))}
        </AntdRow>
      </SectionData>
    </>
  );
};

export default SelectCategoriesStepDesktop;
